import { RootState } from "store/store";
import apiClient from "./apiClient";

/**
 * Helper function to get the Authorization header from Redux store
 */
const getAuthHeader = (state: RootState): string => {
	const accessToken = state.auth.data.access_token;
	return accessToken ? `Bearer ${accessToken}` : "";
};

/**
 * Create Company API Request
 */
export const createCompanyApi = async (
	companyData: Record<string, any>,
	state: RootState,
): Promise<any> => {
	const authHeader = getAuthHeader(state);

	const response = await apiClient.post("/company/", companyData, {
		headers: {
			Authorization: authHeader,
		},
		// withCredentials: true, // Include credentials in the request
	});

	return response.data;
};

/**
 * Update Company API Request
 */
export const updateCompanyApi = async (
	id: number,
	companyData: Record<string, any>,
	state: RootState,
): Promise<any> => {
	const authHeader = getAuthHeader(state);

	const response = await apiClient.put(`/company/${id}`, companyData, {
		headers: {
			Authorization: authHeader,
		},
	});
	return response.data;
};

/**
 * Get Company By ID API Request
 */
export const getCompanyByIdApi = async (
	id: number,
	state: RootState,
): Promise<any> => {
	const authHeader = getAuthHeader(state);

	const response = await apiClient.get(`/company/${id}`, {
		headers: {
			Authorization: authHeader,
		},
	});
	return response.data;
};
